import React from "react";
import PanelTitle from "./PanelTitle";
import PanelHeaderButton from "./PanelHeaderButton";
import PanelSettings from "./PanelSettings";

function PanelHeader(props) {
  let maximizeButton = "";
  if (props.maximize) {
    maximizeButton = (
      <PanelHeaderButton
        action={props.maximize.maximize}
        iconClassName={
          props.maximize.isMaximized ? "icon-resize-small" : "icon-resize-full"
        }
      />
    );
  }

  let closeButton = "";
  if (props.closePanel) {
    closeButton = (
      <PanelHeaderButton
        action={props.closePanel}
        iconClassName="icon-remove"
      />
    );
  }
  return (
    <div className="panel-header">
      <div className="panel-header-title-bar">
        <PanelTitle compositeKey={props.compositeKey} />
        <PanelHeaderButton
          action={props.panelOptions.toggle}
          extraClassNames={props.panelOptions.isOpen ? ["active"] : undefined}
          iconClassName="icon-cog"
        />
        {maximizeButton}
        {closeButton}
      </div>
      <PanelSettings
        panelId={props.panelId}
        activeImageId={props.activeImageId}
        panelOptions={props.panelOptions}
        playbackSpeed={props.playbackSpeed}
        colourCurve={props.colourCurve}
        temperatureDisplayEnabled={props.temperatureDisplayEnabled}
        temperatureDisplayScale={props.temperatureDisplayScale}
        updateTemperatureDisplay={props.updateTemperatureDisplay}
      />
    </div>
  );
}

export default PanelHeader;
